import React from 'react';
import { HtmlTable } from '../CommonComponents/OPL/HtmlTable/HtmlTable';
import { Text } from '../CommonComponents/OPL/Text/Text';
import { TableHead } from './components/TableHead';
import { TableBody } from './components/TableBody';
import { TableRow } from './components/TableRow';
import { PDFTitle } from '../PDFRenderer/components/PDFTitle/PDFTitle';
import { PdfPageWrapper } from '../PDFRenderer/PDFRenderer.styles';
import { InflowOutflowDTO, PeopleDTO, PeriodDTO } from './ProjectedCashFlowReport.meta';

interface Props {
  title: string;
  People: PeopleDTO[];
  Periods: PeriodDTO[];
  PrincipalAges: string[];
  SpouseAges: string[];
  Inflows: InflowOutflowDTO[];
  Outflows: InflowOutflowDTO[];
  InflowsTotals: number[];
  OutflowsTotals: number[];
  NetCashflow: number[];
}

export const ProjectedCashFlowReportPrint = ({
  title,
  People,
  Periods,
  PrincipalAges,
  SpouseAges,
  Inflows,
  Outflows,
  InflowsTotals,
  OutflowsTotals,
  NetCashflow,
}: Props) => {
  return (
    <PdfPageWrapper>
      <PDFTitle title={title} />
      <HtmlTable variant="basic">
        <table>
          <thead>
            <TableHead columns={Periods} title="Period" />
            <TableHead columns={PrincipalAges} title={People[0].Name} />
            {People.length > 1 && <TableHead columns={SpouseAges} title={People[1]?.Name} />}
          </thead>
          <tbody>
            <tr>
              <td colSpan={6}>
                <Text fontSize="h6" fontWeight={600}>
                  Inflow
                </Text>
              </td>
            </tr>
            <TableBody rows={Inflows} />
            <TableRow
              title={'Total Inflow'}
              cells={InflowsTotals}
              forceOdd={true}
              color="success.500"
              fontWeight={600}
            />
            <tr>
              <td colSpan={6}>
                <Text fontSize="h6" fontWeight={600}>
                  Outflow
                </Text>
              </td>
            </tr>
            <TableBody rows={Outflows} />
            <TableRow
              title={'Total Outflow'}
              cells={OutflowsTotals}
              forceOdd={true}
              color="error.500"
              fontWeight={600}
            />
            <TableRow
              title={'Net Cash Flow'}
              cells={NetCashflow}
              forceOdd={true}
              color="black"
              fontWeight={600}
              fontSize="h6"
            />
          </tbody>
        </table>
      </HtmlTable>
    </PdfPageWrapper>
  );
};
